import * as t from 'io-ts';

import {TeammateOnlineStatusesEnum} from '../../store/data/teammates/onlineTeammatesSelectors';
import {makeEnumRuntimeType} from './apiTypes';
import {RCard} from './cardModel';
import {RChannel} from './channelModel';
import {RContact} from './contactModel';
import {RTeammate} from './teammateModel';

/*
 * Runtime type.
 */

const RVisualContactDirty = t.readonly(
  t.intersection([
    t.type({
      contact: RContact,
      namespace: t.string,
    }),
    t.partial({
      fallbackContact: RContact,
      card: RCard,
      fallbackCard: RCard,
      channel: RChannel,
      name: t.string,
      isSpammer: t.boolean,
      teammate: RTeammate,
      onlineStatus: makeEnumRuntimeType(TeammateOnlineStatusesEnum),
    }),
  ]),
);

/*
 * Type.
 */

export interface VisualContactModel extends t.TypeOf<typeof RVisualContactDirty> {}
export const RVisualContact = t.clean<VisualContactModel>(RVisualContactDirty as any);
